import React, { useState, useEffect } from 'react';
import '../css/SystemToast.css';
import { systemMessage } from '../State';
import { useRecoilState } from 'recoil';

const SystemToast = () => {

    const [msg, setMsg] = useRecoilState(systemMessage);
    const [hidden, setHidden] = useState(true);

    useEffect(() => {
        if (msg !== "") {
            setHidden(false);
            fade(3000);
        } else {
            setHidden(true);
        }
    }, [msg]);

    const clearToast = () => {
        setMsg("");
    }

    const fade = (len) => {
        let timer = setTimeout(() => {
            setMsg("");
        }, len);
    }



    return (
        <div className={hidden ? "toast-container hidden" : "toast-container"}>
            <div className="toast-header">
                <p className="toast-close" onClick={clearToast}>x</p>
                <p>System Message:</p>
            </div>
            <div className="toast-main">
                {msg}
            </div>
        </div>
    );
}

export default SystemToast;